import { render } from "./TalentLinkConfirm.vue?vue&type=template&id=122046b4&scoped=true"
import script from "./TalentLinkConfirm.vue?vue&type=script&lang=js"
export * from "./TalentLinkConfirm.vue?vue&type=script&lang=js"

import "./TalentLinkConfirm.vue?vue&type=style&index=0&id=122046b4&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./TalentLinkConfirm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122046b4"]])

export default __exports__